export default __webpack_public_path__ + "static/community-events-section-hero-mobile-d8053065ecd388f5e9fecaf75b2971f2.png";